import { render, staticRenderFns } from "./ErrorReports.vue?vue&type=template&id=041873b3&scoped=true"
import script from "./ErrorReports.vue?vue&type=script&setup=true&lang=js"
export * from "./ErrorReports.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "041873b3",
  null
  
)

export default component.exports